import { createFileRoute } from '@tanstack/react-router';

import { NotificationsPage } from '@/features/parent/NotificationsPage';

export const Route = createFileRoute('/_authed/parent/notifications')({
  component: NotificationsPage,
});
